/**
 * Botón «Mensajes» de la barra (docs/29 §0): junto al chip de créditos, con globo de no leídos
 * (`GET /estado` cada 60 s). Abre el panel de Mensajes del hub: embebida con `opus-hub:ir`
 * { pagina:'mensajes' }; en su propio sitio, la página del hub con `?abrir=mensajes`.
 *
 * Si el hub no tiene Mensajes todavía (404/503, sin red, sin sesión del hub), no se pinta.
 */
import { makeStyles } from '@fluentui/react-components';
import { Chat20Regular } from '@fluentui/react-icons';
import { abrirPanelMensajes, useMensajes } from '../../lib/mensajesDisponibles.js';
import { controlIcono } from '../controlDelHeader.js';

const useStyles = makeStyles({
  btn: { ...controlIcono, position: 'relative' },
  globo: {
    position: 'absolute',
    top: '-5px',
    right: '-5px',
    minWidth: '18px',
    height: '18px',
    padding: '0 5px',
    boxSizing: 'border-box',
    borderRadius: '999px',
    background: 'var(--bad)',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: '18px',
    textAlign: 'center',
    pointerEvents: 'none',
  },
});

/** «9+» a partir de 10 (como el globo del hub). */
export function textoDelGlobo(n: number): string {
  return n > 9 ? '9+' : String(n);
}

export function etiquetaMensajes(n: number): string {
  if (n <= 0) return 'Mensajes';
  return n === 1 ? 'Mensajes · 1 sin leer' : `Mensajes · ${n} sin leer`;
}

export function MensajesBoton({ enHub }: { enHub: boolean }): JSX.Element | null {
  const styles = useStyles();
  const { disponible, estado } = useMensajes();
  if (!disponible) return null;
  const n = estado?.no_leidos ?? 0;
  const etiqueta = etiquetaMensajes(n);
  return (
    <button
      type="button"
      className={styles.btn}
      onClick={() => abrirPanelMensajes(undefined, { enHub })}
      aria-label={etiqueta}
      title={etiqueta}
    >
      <Chat20Regular />
      {n > 0 && (
        <span className={styles.globo} aria-hidden="true">
          {textoDelGlobo(n)}
        </span>
      )}
    </button>
  );
}
